<template>
    <div class="flex items-center justify-between mb-8">

        <Head :title="$t('agencies.title')" />

        <page-title :title="$t('agencies.title')"></page-title>

        <div class="flex md:mt-0 md:ml-4">
            <button type="button"
                    class="ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige focus:outline-none uppercase"
                    @click="$inertia.visitInModal(route('admin.agencies.create'))">
                <PlusSmIcon class="-ml-1 md:mr-2 h-5 w-5 text-white md:text-minplan-darkgreybeige" />
                <span class="hidden md:inline font-bold">{{ $t("agencies.newAgency") }}</span>
            </button>
        </div>
    </div>

    <ul role="list" class="mt-6">
        <li v-for="agency in agencies" :key="agency.uuid">
            <agency-card :agency="agency"></agency-card>
        </li>
    </ul>
</template>

<script>
import MainLayout from "@/Layouts/MainLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import AgencyCard from "@/Pages/Advisor/Agency/Components/AgencyCard";
import { PlusSmIcon } from "@heroicons/vue/outline";
import SettingsLayout from "@/Layouts/SettingsLayout";
import { Head } from "@inertiajs/inertia-vue3";

export default {
    layout: [MainLayout, SettingsLayout],
    props: ['agencies'],
    components: {
        Head,
        AgencyCard,
        PageTitle,
        PlusSmIcon
    }
};
</script>

<style scoped>

</style>
